import * as Yup from 'yup';

export const RecordSchema = Yup.object()
                               .shape({
                                          cardNumber: Yup.object()
                                                         .required('Required'),
                                          address: Yup.object()
                                                      .required('Required'),
                                      });
